<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-5xl">
    <p class="mb-6">
      <a
        routerLink="/admin"
        class="text-sm text-dusk hover:text-parchment hover:underline"
        >&larr; Back to admin dashboard</a
      >
    </p>

    <div class="mb-8">
      <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
        >Site admin</span
      >
      <h1 class="font-display text-3xl font-semibold text-parchment">Competitions</h1>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="search()" class="mb-6 flex gap-3">
      <input
        formControlName="q"
        type="text"
        placeholder="Filter by name…"
        class="flex-1 rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
      />
      <button
        type="submit"
        class="inline-flex shrink-0 items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2.5 text-sm font-bold text-ink transition hover:-translate-y-px"
      >
        Search
      </button>
    </form>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else if (items().length === 0) {
      <p class="text-sm text-dusk">No competitions match.</p>
    } @else {
      <div class="rounded-md border border-hairline bg-panel">
        <ul class="flex flex-col divide-y divide-hairline">
          @for (c of items(); track c.id) {
            <li class="flex flex-col">
              <a
                [routerLink]="['/competitions', c.id]"
                class="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm transition hover:bg-parchment/[0.04]"
              >
                <span class="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-parchment">
                  {{ c.name }}
                  @if (c.ownerIsSiteAdmin) {
                    <span
                      class="shrink-0 rounded-full border border-dusk px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wide text-dusk"
                      >Admin-owned</span
                    >
                  }
                  <span class="w-full whitespace-nowrap text-xs text-dusk sm:w-auto">{{ dateOnly(c.startDate) }} – {{ dateOnly(c.endDate) }}</span>
                </span>
                <span
                  class="shrink-0 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wide"
                  [class.border-gold]="c.status === 'ACTIVE'"
                  [class.text-gold]="c.status === 'ACTIVE'"
                  [class.border-wax-bright]="c.status === 'ON_HOLD'"
                  [class.text-wax-bright]="c.status === 'ON_HOLD'"
                  >{{ c.status === 'ACTIVE' ? 'Active' : 'On hold' }}</span
                >
              </a>

              <div class="flex flex-wrap items-center gap-3 px-4 pb-3 text-xs">
                @if (confirmingId() === c.id) {
                  <span class="text-parchment">
                    Delete every award in this competition and rebuild them from the deaths? Awards
                    given by hand and split amounts entered will be lost.
                  </span>
                  <button
                    type="button"
                    (click)="confirmRecalculate(c)"
                    class="font-semibold text-gold hover:underline"
                  >
                    Yes, recalculate
                  </button>
                  <button
                    type="button"
                    (click)="confirmingId.set(null)"
                    class="text-dusk hover:text-parchment"
                  >
                    Cancel
                  </button>
                } @else {
                  <button
                    type="button"
                    (click)="confirmingId.set(c.id)"
                    [disabled]="recalculatingId() !== null"
                    class="text-gold hover:underline disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {{ recalculatingId() === c.id ? 'Recalculating…' : 'Recalculate scores' }}
                  </button>
                }
                @if (recalcOutcomes()[c.id]; as outcome) {
                  <span [class.text-wax-bright]="outcome.isError" [class.text-dusk]="!outcome.isError">
                    {{ outcome.text }}
                  </span>
                }
              </div>
            </li>
          }
        </ul>
      </div>

      <div class="mt-4 flex items-center justify-between text-sm">
        <button
          type="button"
          (click)="goToPage(page() - 1)"
          [disabled]="page() <= 1"
          class="text-dusk hover:text-parchment disabled:cursor-not-allowed disabled:opacity-40"
        >
          &larr; Previous
        </button>
        <span class="text-xs uppercase tracking-wide text-dusk">
          Page {{ page() }} of {{ totalPages() }} ({{ total() }} total)
        </span>
        <button
          type="button"
          (click)="goToPage(page() + 1)"
          [disabled]="page() >= totalPages()"
          class="text-dusk hover:text-parchment disabled:cursor-not-allowed disabled:opacity-40"
        >
          Next &rarr;
        </button>
      </div>
    }
  </div>
</section>
